import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ModalAgregarMaterial from "views/Modulos/Administracion/Material/ModalAgregarMaterial.jsx";
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class Material extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      idMateriaPrima: '',
      idUnidadMedida: '',
      NombreMaterial: '',
      DescripcionMaterial: '',
      CostoUnidad: '',
      Comportamiento: '',
      Existencia: '',
      ExistenciaMinima: '',
      NombreUnidadMedida: '',
      Material: [],
      MateriasPrimas: [],
      UnidadesMedidas: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombreMaterial: false,
      errorDescripcionMaterial: false,
      errorCostoUnidad: false,
      errorComportamiento: false,
      errorMateriaPrima: false,
      errorUnidadMedida: false,
      errorExistencia: false,
      errorExistenciaMinima: false,
      materialMostrar: [],
      entroFiltrar: false,
      notificacion: false,
      idMateriaPrimaFiltro:1
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarMaterial = this.eliminarMaterial.bind(this);
    this.filtrarMaterial = this.filtrarMaterial.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerMaterialFin();
    this.obtenerMaterial();
    this.obtenerAllMateriasPrimas();
    this.obtenerAllUnidadesMedida();
  }

  obtenerMaterial() {
    fetch(Globales.Url + 'Material/Material/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          //console.log("Error ..."+data.error)
          this.setState({ Material: [] });
        } else { //Obtuvo los registros correctamente
            this.setState({ Material: data.data.length > 0 ? data.data : [] });
            //console.log("Se tiene que mostrar--------------")
        }
      });
  }

  //Obtener todos los registros guardados
  obtenerAllMateriasPrimas() {
    fetch(Globales.Url + 'MateriaPrima/MateriaPrima/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ MateriasPrimas: [] });
        } else { //Obtuvo los registros correctamente
          if(data.mensaje != null){
            this.setState({ MateriasPrimas: data.mensaje });
          }else{
            this.setState({ MateriasPrimas: [] });
          }
        }
      });
  }

  //Obtener todas las unidades de medida
  obtenerAllUnidadesMedida() {
    fetch(Globales.Url + 'UnidadMedida/UnidadMedida/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ UnidadesMedidas: [] });
        } else { //Obtuvo los registros correctamente
          if(data.data != null){
            this.setState({ UnidadesMedidas: data.data });
          }else{
            this.setState({ UnidadesMedidas: [] });
          }
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerMaterialFin() {
    fetch(Globales.Url + 'Material/Material/ListaMaterial', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
        //console.log("🍺 / file: Material.jsx / line 143 / data", data)
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else { //Obtuvo los registros correctamente
              this.setState({ materialMostrar: data.mensaje });
          }
        }).catch(err => console.error(err));
    });
  }

  //Obtiene los nombre de las materias primas
  obtenerNombreMateriaPrima(idMateriaPrima) {
    var nombre = "";
    this.state.MateriasPrimas.map(materiasPrimas => {
      if (materiasPrimas._id == idMateriaPrima) {
        nombre = materiasPrimas.NombreMateria;
      }
    });
    return nombre;
  }

  //Obteniendo el nombre de la unidad de medida
  obtenerNombresUnidadMedida(idUnidadMedida) {
    var nombre = "";
    this.state.UnidadesMedidas.map(unidad => {
      if (unidad._id == idUnidadMedida) {
        nombre = unidad.NombreUnidad
      }
    })
    return nombre;
  }

  //Función de editar registro
  editarMaterial(id, idMateriaPrima, idUnidadMedida, NombreMaterial, DescripcionMaterial, CostoUnidad, Comportamiento, Existencia, ExistenciaMinima) {
    this.setState({ _id: id, idMateriaPrima: idMateriaPrima, idUnidadMedida: idUnidadMedida, NombreMaterial: NombreMaterial, DescripcionMaterial: DescripcionMaterial, CostoUnidad: CostoUnidad, Comportamiento: Comportamiento, Existencia: Existencia, ExistenciaMinima: ExistenciaMinima, op: 1, showAgregar: true, Titulo: "Editar Material" });
  }

  //Función de eliminar registro
  eliminarMaterial(id) {
    fetch(Globales.Url + 'Material/Material/BajaMaterial', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification("tr");
        this.obtenerMaterialFin();
        this.obtenerMaterial();
        this.obtenerAllMateriasPrimas();
        this.obtenerAllUnidadesMedida();
        this.limpiar();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarMaterial(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarMaterial = () => {
    this.setState({ showAgregar: true, Titulo: "Nuevo Material", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalMaterial = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nuevo Material", NombreMaterial: "", op: 0 })
    this.obtenerMaterialFin();
    this.obtenerMaterial();
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion });
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarMaterial() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreMaterial.trim() == '' && true == false ) {
      this.setState({ errorNombre: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreMaterial: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombre: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'Material/Material/FiltrarNombreMaterial', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify({NombreMaterial:this.state.NombreMaterial,idMateriaPrima:(this.state.idMateriaPrimaFiltro == 1?null:this.state.idMateriaPrimaFiltro)})
      }
      ).then(res => res.json())
        .then(data => {

          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.mensaje.length == 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning", materialMostrar:[],  mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', materialMostrar: data.mensaje, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreMaterial: '',idMateriaPrimaFiltro:1, entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.obtenerMaterial();
    this.obtenerMaterialFin();
    this.obtenerAllMateriasPrimas();
    this.obtenerAllUnidadesMedida();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      if(this.state.Material.length <= global.Fin){
        this.setState({ 
          mensaje: 'No hay más materiales para mostrar', 
          colorNotificacion: 'warning'
        });
        this.showNotification();
      }
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.Material.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerMaterialFin();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.Material.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.Material.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerMaterialFin();
      };
    }
  }

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <ModalAgregarMaterial
          Titulo={this.state.Titulo}
          idMateriaPrima={this.state.idMateriaPrima}
          idUnidadMedida={this.state.idUnidadMedida}
          NombreMaterial={this.state.NombreMaterial}
          DescripcionMaterial={this.state.DescripcionMaterial}
          CostoUnidad={this.state.CostoUnidad}
          Comportamiento={this.state.Comportamiento}
          Existencia={this.state.Existencia}
          ExistenciaMinima={this.state.ExistenciaMinima}
          MateriasPrimas={this.state.MateriasPrimas}
          UnidadesMedidas={this.state.UnidadesMedidas}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalMaterial}
          op={this.state.op}
          classes={this.props}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        {/* <Hidden xsDown implementation="css"> */}
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Materiales</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Buscar material"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreMaterial,
                        name: "NombreMaterial",
                        id: "NombreMaterial",
                        type: "text",
                        error: this.state.errorNombre
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem  xs={12} sm={12} md={3}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                    error={this.state.errorMateriaPrima}
                    className="mt-4"
                  >
                    <InputLabel
                      className={classes.selectLabel}>
                      Materia Prima
                        </InputLabel>
                    <Select
                      value={this.state.idMateriaPrimaFiltro}
                      onChange={this.handleChange}
                      name="idMateriaPrimaFiltro"
                      inputProps={{
                      }}
                    >
                      <MenuItem value={1}>Todas</MenuItem>
                      {this.state.MateriasPrimas.map(materiaPrima =>
                        <MenuItem value={materiaPrima._id}>{materiaPrima.NombreMateria}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarMaterial()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />Limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarMaterial()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de materiasPrimas */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={10}>
                    <h4 className="pull-left">Lista de Materiales</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Nombre Material</th>
                        <th className="center">Materia Prima</th>
                        <th className="center">Unidad de Medida</th>
                        <th className="center">Costo Unidad</th>
                        <th className="center">Existencia</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.materialMostrar.map(material => {
                          return (
                            <tr key={material._id}>
                              <td>{material.NombreMaterial}</td>
                              <td>{this.obtenerNombreMateriaPrima(material.idMateriaPrima)}</td>
                              <td>{this.obtenerNombresUnidadMedida(material.idUnidadMedida)}</td>
                              <td>{material.CostoUnidad}</td>
                              <td>{material.Existencia}</td>
                              <td className="pull-right">
                                <Button tabIndex="0" size="sm" color="warning" round justIcon onClick={() => this.editarMaterial(material._id, material.idMateriaPrima, material.idUnidadMedida, material.NombreMaterial, material.DescripcionMaterial, material.CostoUnidad, material.Comportamiento, material.Existencia, material.ExistenciaMinima)}><Edit /></Button>
                                <Button size="sm" color="danger" round justIcon onClick={() => this.deleteEvent(material._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>
                }
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Material"}
            Cuerpo={"¿Está seguro que desea eliminar el material"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(Material);
